import { useMemo } from 'react'

import { sortBy } from 'lodash-es'

import { Appointment } from '@lyrahealth-inc/shared-app-logic/src/models/appointment/Appointment'
import { APPOINTMENT_STATUS } from '@lyrahealth-inc/shared-app-logic/src/models/session/Session'

import { useClientAppointmentsData } from '../../clients/clientDetails/data/hooks/useClientAppointmentsData'

type AISummariesPanelData = {
  lastAppointmentDate: string | null
  isLoading: boolean
}

/**
 * Hook to fetch data for the AI Summaries panel
 * Gets the last completed session date from client appointments
 */
const useAISummariesPanelData = (): AISummariesPanelData => {
  const { data: appointments, isLoading } = useClientAppointmentsData()

  const lastAppointmentDate = useMemo(() => {
    if (!appointments || appointments.length === 0) {
      return null
    }

    // Filter for completed appointments only
    const completedAppointments = appointments.filter(
      (appt: Appointment) =>
        appt.appointmentStatus === APPOINTMENT_STATUS.COMPLETED || appt.appointmentStatus === 'concluded',
    )

    if (completedAppointments.length === 0) {
      return null
    }

    // Sort by startDate descending and get the most recent
    const sortedAppointments = sortBy(completedAppointments, (appt) => new Date(appt.startDate).getTime() * -1)

    return sortedAppointments[0]?.startDate ?? null
  }, [appointments])

  return {
    lastAppointmentDate,
    isLoading,
  }
}

export default useAISummariesPanelData
